<template>
  <div>
    <!--
    <table class="table table-responsive">
      <thead>
        <tr>
          <th scope="col" v-for="header in headers">{{header}}</th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="row in chartData">
          <td v-for="header in headers">
            {{row[header]}}
          </td>
        </tr>
      </tbody>
    </table>
    -->
    <b-col lg="3" class="tbl_filter">
        <b-form-group
          label=""
          label-for="filter-input"
          label-align-sm="right"
          label-size="sm"
          class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="type in search term"
            ></b-form-input>
            <template v-if="filter">
              <b-input-group-append>
                <b-button class="btn_clear_srh" @click="filter = ''" title="clear search">
                  <span class="ic9-close1"></span>
                </b-button>
              </b-input-group-append>
            </template>
          </b-input-group>
        </b-form-group>
      </b-col>
    <b-table
      :items="chartData"
      :fields="chartHeader"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :filter="filter"
      :filter-included-fields="filterOn"
      :class="'table-fixed'"
    ></b-table>
  </div>
</template>
<script>
export default {
  name: 'tableChart',
  props: ['chartData', 'headers', 'options', 'name'],
  mounted () {
  },
  data: () => {
    return {
      sortBy: 'Course Title',
      sortDesc: false,
      filter: null,
      filterOn: []
    }
  },
  computed: {
    chartHeader () {
      let chartHeader = []
      if (this.headers && this.headers.length > 0) {
        this.headers.forEach((item, i) => {
          chartHeader.push( {
            key: item,
            sortable: true
          })
        })
      }
      return chartHeader
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/institution/components/TableChart.vue